import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { status } from 'constants/general';
import postsStrings from 'modules/posts/strings';
import PostsHeader from 'modules/posts/components/PostsHeader';
import PostsFilter from 'modules/posts/components/PostsFilter';
import PostsList from 'modules/posts/components/PostsList';
import Loader from 'modules/common/components/Loader';
import SectionDivider from 'modules/common/components/SectionDivider';
import Popup from 'modules/common/components/Popup';

import {
  PostsWrapper,
  LoaderWrapper,
  NoResultsWrapper,
  NoResultsText,
  ImgPreview,
  VideoPreview,
  VideoPreviewSrc,
  ToastTextOverlay,
} from './PostsComponent.style';

const PostsComponent = ({
  isFetchingMorePosts,
  showCopiedTextOverlay,
  searchQuery,
  isPreviewFilePopupOpen,
  previewFileData,
  isActionPopupOpen,
  isActionPopupLoading,
  handleTextToCopyToClipboardClick,
  handleAddPostBtnClick,
  handleSearchBarInputChange,
  handlePreviewFileClick,
  handleActionBtnClick,
  handleActionPopupConfirmBtnClick,
  handleActionPopupDismissBtnClick,
}) => {
  const { staticData, companyProfilesList, postsList } = useSelector(state => ({
    staticData: state.common.staticData,
    companyProfilesList: state.common.companyProfilesList,
    postsList: state.posts.postsList,
  }));

  const postsListArr = postsList?.details?.results;

  const renderPostsList = () => {
    if (
      ((postsList.status === status.SHOULD_CALL_API || postsList.status === status.FETCHING) &&
        !postsList.details?.results) ||
      staticData.status === status.SHOULD_CALL_API ||
      staticData.status === status.FETCHING ||
      companyProfilesList.status === status.SHOULD_CALL_API ||
      companyProfilesList.status === status.FETCHING
    )
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (
      (postsList.status === status.SUCCESS && postsListArr?.length === 0) ||
      postsList.status === status.FAIL
    )
      return (
        <NoResultsWrapper>
          <NoResultsText>{postsStrings.postsList.postsGridNoResultsFound}</NoResultsText>
        </NoResultsWrapper>
      );

    return (
      <>
        <PostsList
          postsListArr={postsListArr}
          isActionPopupOpen={isActionPopupOpen}
          isActionPopupLoading={isActionPopupLoading}
          handleTextToCopyToClipboardClick={handleTextToCopyToClipboardClick}
          handlePreviewFileClick={handlePreviewFileClick}
          handleActionBtnClick={handleActionBtnClick}
          handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
          handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
        />
        {isFetchingMorePosts && (
          <>
            <SectionDivider gap={30} />
            <LoaderWrapper>
              <Loader width={40} height={40} thickness={6} />
            </LoaderWrapper>
          </>
        )}
        {isPreviewFilePopupOpen && (
          <Popup handleCloseBtnClick={() => handlePreviewFileClick(false)}>
            {(previewFileData.type === 'image' && <ImgPreview src={previewFileData.url} />) || (
              <VideoPreview controls>
                <VideoPreviewSrc src={previewFileData.url} />
              </VideoPreview>
            )}
          </Popup>
        )}
        {showCopiedTextOverlay && (
          <ToastTextOverlay>{postsStrings.postsList.copiedToClipboardText}</ToastTextOverlay>
        )}
      </>
    );
  };

  return (
    <>
      <PostsHeader handleAddPostBtnClick={handleAddPostBtnClick} />
      <PostsWrapper id="posts-wrapper">
        <PostsFilter
          searchQuery={searchQuery}
          handleSearchBarInputChange={handleSearchBarInputChange}
        />
        {renderPostsList()}
      </PostsWrapper>
    </>
  );
};

PostsComponent.propTypes = {
  isFetchingMorePosts: PropTypes.bool.isRequired,
  showCopiedTextOverlay: PropTypes.bool.isRequired,
  searchQuery: PropTypes.string.isRequired,
  isPreviewFilePopupOpen: PropTypes.bool.isRequired,
  previewFileData: PropTypes.shape({
    type: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  isActionPopupOpen: PropTypes.bool.isRequired,
  isActionPopupLoading: PropTypes.bool.isRequired,
  handleTextToCopyToClipboardClick: PropTypes.func.isRequired,
  handleAddPostBtnClick: PropTypes.func.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handlePreviewFileClick: PropTypes.func.isRequired,
  handleActionBtnClick: PropTypes.func.isRequired,
  handleActionPopupConfirmBtnClick: PropTypes.func.isRequired,
  handleActionPopupDismissBtnClick: PropTypes.func.isRequired,
};

export default PostsComponent;
